const API_URL = process.env.REACT_APP_API_URL;

const headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/json');

class ApiClass {
	constructor(setLoading) {
		if (setLoading && typeof setLoading === 'function') this.setLoading = setLoading;
		else this.setLoading = () => {};
	}

	Login = async ({ userName, password }) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/login`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ userName, password }),
			});
			if (data && !data.unauthorized && !data.forbidden && !data.needsOtp) {
				data.token = this.attachAuth(userName, password);
			}
			return data;
		} catch (ex) {
			console.error('login', ex.message);
			return null;
		}
	};

	Logout = () => {
		try {
			this.detachAuth();
			sessionStorage.removeItem('user');
		} catch (ex) {
			console.error('logout', ex.message);
			return null;
		}
	};

	//Forgot my password
	SendVerificationCode = async email => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/SendVerificationCode?email=${email}`, { headers, method: 'POST' });

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('SendVerificationCode', ex.message);
			return null;
		}
	};

	CheckVerificationCode = async (userId, code) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/CheckVerificationCode`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ userId, code }),
			});

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('CheckVerificationCode', ex.message);
			return null;
		}
	};

	UpdateUserPassword = async (userId, password) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateUserPassword`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ userId, password }),
			});

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateUserPassword', ex.message);
			return null;
		}
	};

	//Translations
	GetTranslations = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetTranslations`);
			if (data && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetTranslations', ex.message);
			return null;
		}
	};

	UpdateUserPreferredLanguage = async ({ userId, preferredLanguageId }) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateUserPreferredLanguage`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ userId, preferredLanguageId }),
			});

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateUserPreferredLanguage', ex.message);
			return null;
		}
	};

	//COURSES
	GetUserCourses = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetUserCourses`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetUserCourses', ex.message);
			return null;
		}
	};

	UpdateChapterStatus = async (recordId, chapterId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateChapterStatus`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ recordId, chapterId }),
			});

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateChapterStatus', ex.message);
			return null;
		}
	};

	GetTestForCourseChapter = async (courseId, chapterId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetTestForCourseChapter?courseId=${courseId}&chapterId=${chapterId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetTestForCourseChapter', ex.message);
			return null;
		}
	};

	UpdateTestStudent = async test => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateTestStudent`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(test),
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateTestStudent', ex.message);
			return null;
		}
	};

	GetStudentAnswers = async (testId, recordId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetStudentAnswers?testId=${testId}&recordId=${recordId}`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetStudentAnswers', ex.message);
			return null;
		}
	};

	UpdateTestStatus = async recordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateTestStatus?recordId=${recordId}`, {
				headers,
				method: 'PUT',
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateTestStatus', ex.message);
			return null;
		}
	};

	GetCertificate = async recordId => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetCertificate?recordId=${recordId}`,
				{ headers, method: 'GET' },
				this.#handleFile
			);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCertificate', ex.message);
			return null;
		}
	};

	GetCertificatePng = async recordId => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetCertificatePng?recordId=${recordId}`,
				{ headers, method: 'GET' },
				this.#handleFile
			);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCertificate', ex.message);
			return null;
		}
	};

	GetDynamicLinks = async (linkGroupId, roleId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetDynamicLinks?linkGroupId=${linkGroupId}&roleId=${roleId}`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetDynamicLinks', ex.message);
			return null;
		}
	};

	GetLpCategories = async () => {
		try {
			const LpApiURL = process.env.REACT_APP_LP_API_URL;
			const res = await fetch(LpApiURL + `GetCategoriesAndSubcategories`);
			if (res.ok) {
				const data = await res.json();
				if (data !== null && data.length > 0) return data;
			}
			return null;
		} catch (ex) {
			console.error('GetLpCategories', ex.message);
			return null;
		}
	};
	GetCategoriesByEmail = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetCategoriesByEmail`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCategoriesByEmail', ex.message);
			return null;
		}
	};

	InsertUserCategory = async (subCategoryId, freeText, email) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertUserCategory`, {
				headers,
				method: 'POST',
				body: JSON.stringify({
					SubCategoryId: subCategoryId,
					FreeText: freeText,
					email,
				}),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertUserCategory', ex.message);
			return null;
		}
	};

	DeleteUserCategory = async categoryRecordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/DeleteUserCategory?categoryRecordId=${categoryRecordId}`, {
				headers,
				method: 'DELETE',
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('DeleteUserCategory', ex.message);
			return null;
		}
	};

	//ESL
	GetActivationCode = async recordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetActivationCode?recordId=${recordId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetActivationCode', ex.message);
			return null;
		}
	};

	// #region prepMyFuture - disabled
	// OnlinePlatformPrepMyFuture = async recordId => {
	// 	try {
	// 		const data = await this.#fetchWithloader(API_URL + `/api/PrepMyFutureAPI`, {
	// 			headers,
	// 			method: 'POST',
	// 			body: JSON.stringify({ recordId }),
	// 		});
	// 		if (data && !data.unauthorized && !data.forbidden) return data;
	// 		return null;
	// 	} catch (ex) {
	// 		console.error('PrepMyFutureAPI', ex.message);
	// 		return null;
	// 	}
	// };
	// #endregion

	//HTML EDITOR
	GetAllAvailableCourses = async teacherId => {
		const link = teacherId ? `/api/GetAllAvailableCourses?teacherId=${teacherId}` : `/api/GetAllAvailableCourses`;
		try {
			const data = await this.#fetchWithloader(API_URL + link);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllAvailableCourses', ex.message);
			return null;
		}
	};

	//IELTS
	UpdateFirstCourseStatus = async recordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateFirstCourseStatus`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ recordId }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateFirstCourseStatus', ex.message);
			return null;
		}
	};

	//MANAGEMENT
	//STUDENT MANAGEMENT
	GetAllManagementDDLS = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllDDLS`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllDDLS', ex.message);
			return null;
		}
	};

	SearchCustomers = async searchParams => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/SearchCustomers`, {
				headers,
				method: 'POST',
				body: JSON.stringify(searchParams),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('SearchCustomers', ex.message);
			return null;
		}
	};

	GetCoordinatorStatusHistory = async (courseId, recordId, userId) => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetCoordinatorStatusHistory?courseId=${courseId}&recordId=${recordId}&userId=${userId}`
			);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCoordinatorStatusHistory', ex.message);
			return null;
		}
	};

	GetCourseStatusHistory = async (courseId, recordId, userId) => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetCourseStatusHistory?courseId=${courseId}&recordId=${recordId}&userId=${userId}`
			);

			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCourseStatusHistory', ex.message);
			return null;
		}
	};

	UpdateStudentStatusesHistory = async statuses => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateStudentStatusesHistory`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(statuses),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateStatuses', ex.message);
			return null;
		}
	};

	GetStudentAndTeacherMeetings = async (studentId, teacherId, recordId) => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetStudentAndTeacherMeetings?StudentId=${studentId}&TeacherId=${teacherId}&recordId=${recordId}`
			);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetStudentAndTeacherMeetings', ex.message);
			return null;
		}
	};

	GetAllCourseTeachers = async courseId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllCourseTeachers?courseId=${courseId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllCourseTeachers', ex.message);
			return null;
		}
	};

	InsertMeeting = async meeting => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertMeeting`, {
				headers,
				method: 'POST',
				body: JSON.stringify(meeting),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertMeeting', ex.message);
			return null;
		}
	};

	UpdateMeeting = async meeting => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateMeeting`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(meeting),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateMeeting', ex.message);
			return null;
		}
	};

	DeleteMeeting = async meetingId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/DeleteMeeting?meetingId=${meetingId}`, { headers, method: 'DELETE' });
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('DeleteMeeting', ex.message);
			return null;
		}
	};

	UpdateStudentCourseTeacher = async courseAndTeacher => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateStudentCourseTeacher`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(courseAndTeacher),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateStudentCourseTeacher', ex.message);
			return null;
		}
	};

	//CLASSES MANAGEMENT
	SearchClasses = async searchParams => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/SearchCourseClasses`, {
				headers,
				method: 'POST',
				body: JSON.stringify(searchParams),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('SearchClasses', ex.message);
			return null;
		}
	};

	GetNewClassAvailableStudents = async (classId, courseId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetCourseClassAvailableStudents`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ classId, courseId }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetNewClassAvailableStudents', ex.message);
			return null;
		}
	};

	InsertUpdateClass = async params => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertUpdateCourseClass`, {
				headers,
				method: 'POST',
				body: JSON.stringify(params),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertNewClass', ex.message);
			return null;
		}
	};

	AssignStudentsToClass = async (classId, recordIds, remark, isSend) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/AssignStudentsToClass`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ classId, recordIds, remark, isSend }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('AssignStudentsToClass', ex.message);
			return null;
		}
	};

	GetAllCoursesMeetings = async classId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllCoursesMeetings?classId=${classId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllCoursesMeetings', ex.message);
			return null;
		}
	};

	InsertCourseClassMeeting = async (classId, meetings, sendMeetingNotification) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertCourseClassMeeting`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ classId, meetings, sendMeetingNotification }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertCourseClassMeeting', ex.message);
			return null;
		}
	};

	InsertMultipleMeetings = async (meetings, recordId, teacherId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertMultipleMeetings`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ meetings, recordId, teacherId }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertMultipleMeetings', ex.message);
			return null;
		}
	};

	UpdateMultipleMeetings = async (meetings, recordId, teacherId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateMultipleMeetings`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ meetings, recordId, teacherId }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateMultipleMeetings', ex.message);
			return null;
		}
	};

	UpdateCourseClassMeeting = async meeting => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateCourseClassMeeting`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ ...meeting }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateCourseClassMeeting', ex.message);
			return null;
		}
	};

	DeleteCourseClassMeeting = async meetingId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/DeleteCourseClassMeeting?meetingId=${meetingId}`, {
				headers,
				method: 'DELETE',
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('DeleteCourseClassMeeting', ex.message);
			return null;
		}
	};

	//Checks if a video poster (preview image) exists on the server.
	isVideoPosterAvailable = async url => {
		try {
			const res = await fetch(url, { method: 'HEAD' });
			if (res && res?.ok) return res?.ok; //boolean value.
			return null;
		} catch (ex) {
			console.error('isVideoPosterAvailable', ex.message);
			return null;
		}
	};

	GetVideosSubtitlesLang = async courseId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetVideosSubtitlesLang?courseId=${courseId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetVideosSubtitlesLang', ex.message);
			return null;
		}
	};

	UpdateReviewDisplayMode = async CourseReview => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateReviewDisplayMode`, {
				headers,
				method: 'POST',
				body: JSON.stringify(CourseReview),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateReviewDisplayMode', ex.message);
			return null;
		}
	};

	//Advanced user management
	GetUsersList = async query => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetUsersListLike?userName=${query}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetUsersList', ex.message);
			return null;
		}
	};

	GetUserDetailsByUserId = async userId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetUserDetailsByUserId?userId=${userId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetUserDetailsByUserId', ex.message);
			return null;
		}
	};

	UpdateUserDetails = async user => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateUserDetails`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(user),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateUserDetails', ex.message);
			return null;
		}
	};

	ResendTriggerEmail = async (emailTypeId, recordId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/ResendTriggerEmail?emailTypeId=${emailTypeId}&recordId=${recordId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('ResendTriggerEmail', ex.message);
			return null;
		}
	};

	InsertUpdateUsersList = async orderId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertUpdateUsersList`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ orderId: parseInt(orderId), isMinOk: true }), //isMinOk: true - Skips the logic of the minimum price and automatically opens the course to the customer
			});
			if (data) return data;
			return null;
		} catch (ex) {
			console.error('InsertUpdateUsersList', ex.message);
			return null;
		}
	};

	ResetTestTimerIELTS = async (userId, recordId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/ResetTestTimerIELTS`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ userId, recordId }),
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('ResetTestTimerIELTS', ex.message);
			return null;
		}
	};

	ResetActivationCodeESL = async (userId, recordId) => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/ResetActivationCodeESL`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ userId, recordId }),
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('ResetActivationCodeESL', ex.message);
			return null;
		}
	};

	TransferCoursesToUserId = async transferData => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/ModifyUserCoursesByUserId`, {
				headers,
				method: 'POST',
				body: JSON.stringify(transferData),
			});
			if (data) return data;
			return null;
		} catch (ex) {
			console.error('TransferCoursesToUserId', ex.message);
			return null;
		}
	};

	//Advanced courses management
	GetCoursesWithActiveSubtitles = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetCoursesWithActiveSubtitles`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetCoursesWithActiveSubtitles', ex.message);
			return null;
		}
	};

	UpdateCoursesWithActiveSubtitles = async ({ courseId, languageId, isActive, files = [], updateSubsActivity = false }) => {
		try {
			const _files = new FormData();
			files.forEach((file, i) => _files.append(`file-${i}`, file));

			//headers
			const _headers = new Headers();
			_headers.append('Access-Control-Allow-Origin', '*');
			_headers.append('Authorization', `Basic ${window.token}`);

			const data = await this.#fetchWithloader(
				API_URL +
					`/api/UpdateCoursesWithActiveSubtitles?courseId=${courseId}&languageId=${languageId}&IsActive=${isActive}&updateSubsActivity=${updateSubsActivity}`,
				{
					headers: _headers,
					method: 'POST',
					body: _files,
				}
			);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateCoursesWithActiveSubtitles', ex.message);
			return null;
		}
	};

	//IELTS TEST
	GetStudentTestStartTime = async recordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetStudentTestStartTime?recordId=${recordId}`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetStudentTestStartTime', ex.message);
			return null;
		}
	};

	UpdateStudentTestStartTime = async recordId => {
		recordId = parseInt(recordId);
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/UpdateStudentTestStartTime`, {
				headers,
				method: 'PUT',
				body: JSON.stringify({ recordId }),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('UpdateStudentTestStartTime', ex.message);
			return null;
		}
	};

	//Review Page
	GetReviewQuestions = async recordId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetReviewQuestions?recordId=${recordId}`, {
				headers,
				method: 'GET',
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetReviewQuestions', ex.message);
			return null;
		}
	};

	GetAllReviews = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllReviews`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllReviews', ex.message);
			return null;
		}
	};
	GetAllTestimonials = async mode => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllTestimonials?mode=${mode}`);
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllTestimonials', ex.message);
			return null;
		}
	};

	InsertReviewQuestionnaireAnswers = async reviewAnswers => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertReviewQuestionnaireAnswers`, {
				headers,
				method: 'POST',
				body: JSON.stringify(reviewAnswers),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertReviewQuestionnaireAnswers', ex.message);
			return null;
		}
	};

	//CONVERSATIONS
	//GET
	GetAllConversationsByUserId = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllConversationsByUserId`, {
				//connected user
				headers,
				method: 'GET',
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllConversationsByUserId', ex.message);
			return null;
		}
	};
	GetAllMessagesByConversationId = async conversationId => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetAllMessagesByConversationId?conversationId=${conversationId}`, {
				headers,
				method: 'GET',
			});
			if (data !== null && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetAllMessagesByConversationId', ex.message);
			return null;
		}
	};

	GetConversationUsersListLike = async (teacherUserId, query) => {
		try {
			const data = await this.#fetchWithloader(
				API_URL + `/api/GetConversationUsersListLike?teacherUserId=${teacherUserId}&userName=${query}`
			);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetConversationUsersListLike', ex.message);
			return null;
		}
	};

	GetConversationSegment = async segmentObj => {
		try {
			const { conversationId, messageId, scrollFlag, directionFlag } = segmentObj;
			const data = await this.#fetchWithloader(
				API_URL +
					`/api/GetConversationSegment?conversationId=${conversationId}&messageId=${messageId}&scrollFlag=${scrollFlag}&directionFlag=${directionFlag}`
			);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetConversationSegment', ex.message);
			return null;
		}
	};

	//POST
	SearchConversations = async searchQuery => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/SearchConversations`, {
				headers,
				method: 'POST',
				body: JSON.stringify(searchQuery),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('SearchConversations', ex.message);
			return null;
		}
	};

	InsertUpdateConversation = async conversationData => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/InsertUpdateConversation`, {
				headers,
				method: 'POST',
				body: JSON.stringify(conversationData),
			});
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('InsertUpdateConversation', ex.message);
			return null;
		}
	};

	InsertUpdateConversationMessage = async conversationMessage => {
		try {
			const res = await this.#fetchWithloader(API_URL + `/api/InsertUpdateConversationMessage `, {
				headers,
				method: 'POST',
				body: JSON.stringify(conversationMessage),
			});

			if (res && !res.unauthorized && !res.forbidden) return res;
			return null;
		} catch (ex) {
			console.error('InsertUpdateConversationMessage', ex.message);
			return null;
		}
	};

	//PUT
	UpdateConversationMessageStatus = async conversationId => {
		try {
			const res = await fetch(API_URL + `/api/UpdateConversationMessageStatus?conversationId=${conversationId}`, {
				headers,
				method: 'PUT',
			});
			const data = await res.json();
			if (!res || (res.status !== 200 && !data.ok)) return null;
			return data;
		} catch (ex) {
			console.error('UpdateConversationMessageStatus', ex.message);
			return null;
		}
	};

	//MyCourse
	GetDynamicParams = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetDynamicParams`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetDynamicParams', ex.message);
			return null;
		}
	};

	GetMyCourseEditFormDetailsApplicantList = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetMyCourseEditFormDetailsApplicantList`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetMyCourseEditFormDetailsApplicantList', ex.message);
			return null;
		}
	};
	GetMyCourseApplicantList = async () => {
		try {
			const data = await this.#fetchWithloader(API_URL + `/api/GetMyCourseApplicantList`);
			if (data && !data.unauthorized && !data.forbidden) return data;
			return null;
		} catch (ex) {
			console.error('GetMyCourseApplicantList', ex.message);
			return null;
		}
	};

	//MyCourse ESL form want to start
	SaveMyCourseForm = async userDetails => {
		try {
			const res = await fetch(API_URL + `/api/SaveMyCourseForm`, {
				headers,
				method: 'POST',
				body: JSON.stringify(userDetails),
			});

			if (!res || (res.status !== 200 && !res.ok)) return null;
			const data = await res.json();
			return data;
		} catch (ex) {
			console.error('SaveMyCourseForm', ex.message);
			return null;
		}
	};

	//sending change user details request (PersonalArea->MyInfo)
	SaveMyCourseFormUpdate = async userDetails => {
		try {
			const res = await this.#fetchWithloader(API_URL + `/api/SaveMyCourseFormUpdate`, {
				headers,
				method: 'POST',
				body: JSON.stringify({
					firstName: userDetails.first_name,
					lastName: userDetails.last_name,
					email: userDetails.email,
					phone: userDetails.phone,
				}),
			});

			if (res && !res.unauthorized && !res.forbidden) return res;
			return null;
		} catch (ex) {
			console.error('SaveMyCourseFormUpdate', ex.message);
			return null;
		}
	};

	//for update the server when the user watched the information change
	MyCourseFormUpdateIsWatched = async () => {
		try {
			const res = await this.#fetchWithloader(API_URL + `/api/MyCourseFormUpdateIsWatched`, {
				headers,
				method: 'PUT',
			});

			if (res && !res.unauthorized && !res.forbidden) return res;
			return null;
		} catch (ex) {
			console.error('MyCourseFormUpdateIsWatched', ex.message);
			return null;
		}
	};

	//for both treated statuses on Change Info Module
	//pass recordId if its MyCourseForm to update treated status
	UpdateMyCourseFormStatus = async details => {
		try {
			const res = await this.#fetchWithloader(API_URL + `/api/UpdateMyCourseFormStatus`, {
				headers,
				method: 'PUT',
				body: JSON.stringify(details),
			});

			if (res && !res.unauthorized && !res.forbidden) return res;
			return null;
		} catch (ex) {
			console.error('UpdateMyCourseFormStatus ', ex.message);
			return null;
		}
	};

	ValidateOtp = async (userName, password, otp) => {
		try {
			const res = await this.#fetchWithloader(API_URL + `/api/ValidateOtp`, {
				headers,
				method: 'POST',
				body: JSON.stringify({ userName, password, otp }),
			});

			if (res && !res.unauthorized && !res.forbidden) {
				res.token = this.attachAuth(userName, password);
			}
			return res;
		} catch (ex) {
			console.error('ValidateOtp', ex.message);
			return null;
		}
	};

	//UTILS Auth
	attachAuth = (username, password, token) => {
		if (!token) {
			token = window.btoa(`${username}:${password}`);
		}
		window.token = token;
		headers.set('Authorization', `Basic ${token}`);
		return token;
	};

	detachAuth = () => {
		if (window.token) {
			delete window.token;
			headers.set('Authorization', ``);
		}
	};

	//fetch middleware
	#handleUnauthorized = async res => {
		try {
			if (!res) return null;
			if (res.status === 200) {
				const data = await res.json();
				return data;
			} else if (res.status === 401) {
				res.errorMessage = 'Invalid username or password.';
				res.unauthorized = true;
			}
			return null;
		} catch (error) {
			console.error(error);
		}
	};

	#handleFile = async res => {
		try {
			if (!res) return undefined;
			const blob = await res.blob();
			return blob;
		} catch (error) {
			console.error(error);
		}
	};

	#fetchWithloader = async (url, options = { headers, method: 'GET' }, callMiddleware = this.#handleUnauthorized) => {
		let debounceTimeOut; //to use loader only if needed and not for few milliseconds
		try {
			debounceTimeOut = setTimeout(() => this.setLoading(true), 150);
			if (window.token && !headers.has('Authorization')) this.attachAuth(null, null, window.token);
			return await fetch(url, options).then(callMiddleware);
		} catch (error) {
			console.warn(error);
		} finally {
			clearTimeout(debounceTimeOut);
			this.setLoading(false);
		}
	};
}

export default ApiClass;
